import React from "react";
import TainanLogo from "../images/tainan_logo.svg";
import MobileNav from "./MobileNav";
import { trackEvent } from "../utils/analytics";

const Header = (props) => {
    const { mobileNavOpen, menuContent, toggleMobileNav } = props;

    // 埋設 GA 點擊 Navbar 按鈕傳送參數
    const sendGaEventNavbar = (e) => {
        trackEvent("event", "Click", {
            "event_category": "Sheet",
            "event_label": e.currentTarget.dataset.label,
            "value": 1
        });
    };

    // 埋設 GA 點擊 2022 潮味台南按鈕傳送參數
    const sendGaEvent2022Tainan = (e) => {
        trackEvent("event", "Click", {
            "event_category": "2022Chill",
            "event_label": "2022Chill_click",
            "value": 1
        });
    };

    return (
        <header className={`${mobileNavOpen ? "header" : "header height-modify"}`}>
            <div className="logo">
                <a
                    className="pixnet-logo"
                    href="https://www.pixnet.net/"
                    target="_blank"
                    rel="noreferrer"
                >
                    痞客邦
                </a>
                <img src={TainanLogo} width={64} height={55} alt="tainan-logo" />
            </div>
            <ul className="navbar">
                {
                    menuContent.map((item, i) => (
                        <li className="menu-item" key={item.id}>
                            <a
                                href="/"
                                onClick={(e) => {
                                    let element = document.getElementById(item.id);
                                    e.preventDefault();
                                    element && element.scrollIntoView({ behavior: "smooth", block: "start" });
                                    sendGaEventNavbar(e);
                                }}
                                data-label={`Sheet${i + 1}_click`}
                                rel="noreferrer"
                            >
                                {item.title}
                            </a>
                        </li>
                    ))
                }
                <li className="menu-item">
                    <a
                        href="https://chill-tainan2022.events.pixnet.net/"
                        target="_blank"
                        onClick={sendGaEvent2022Tainan}
                        rel="noreferrer"
                    >
                        潮Way台南
                    </a>
                </li>
            </ul>
            <MobileNav
                mobileNavOpen={mobileNavOpen}
                menuContent={menuContent}
                toggleMobileNav={toggleMobileNav}
            />
        </header>
    );
};

export default Header;
